<lib-card [title]="'Upload photo'" [subtitle]="'Both you and client can upload gallery photos'">
	<ui-file-form-field
		[validation]="'images'"
		[standalone]="true"
		[isRequired]="false"
		[maxFiles]="undefined"
		[imageCrop]="undefined"
		[uploadFunction]="uploadFunction"
		(valueChange)="handleFilesChange($event)"
	></ui-file-form-field>
</lib-card>

<div class="push-top">
	@if (clientGalleryFiles(); as clientGalleryFiles) { @if (clientGalleryFiles.length) {
	<div [libFlexRow]="true" [libFlexRowGap]="'16px'" [libFlexRowAlign]="'stretch'">
		@for (file of clientGalleryFiles; track file.fileReference.absoluteUrl; let first = $first) {
		<div libFlexColumn [style.width]="calculateFlexWidth(isMobileView() ? 1 : 3, 24)">
			<lib-card [removePadding]="true" style="height: 100%">
				<div class="pad">
					<div libFlexRow [libFlexRowGap]="'16px'">
						<div libFlexColumn libFlexFill>
							<div libText1 libLineClamp [clampLines]="1">
								{{ file.fileReference.originalFilename }}
							</div>
							<div libText4>
								{{ formatDate(file.fileReference.created) }}
							</div>
						</div>
						<div libFlexColumn>
							<lib-button-list [mode]="'single'" [buttons]="file.buttons"></lib-button-list>
						</div>
					</div>

					<div class="push-top-sm">
						<lib-image
							[alt]="'Client gallery image'"
							[isRound]="false"
							[isResponsive]="true"
							[imageSize]="'250px'"
							[image]="file.fileReference.image"
							[dialogPreviewImage]="file.fileReference.image"
						></lib-image>
					</div>
				</div>
			</lib-card>
		</div>
		}
	</div>
	} @else {
	<lib-message [type]="'noDataOnBody'">
		@if (authUserIsClient()) { You have no gallery photos } @else { Client has no gallery photos }
	</lib-message>
	} }
</div>
